// extracted by mini-css-extract-plugin
module.exports = {"errorBackround":"ErrorMessage_errorBackround__1bR-C","backdrop":"ErrorMessage_backdrop__2pafG","redo":"ErrorMessage_redo__2W8TZ"};